/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = CheckBox
 *
 * 1 = GroupInput
 */
export enum CheckInstanceType {
  CheckBox = 0,
  GroupInput = 1,
}
